import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Footer from "../../components/feature/Footer";

const socials = [
  { name: "YouTube", icon: "ri-youtube-line", url: "https://www.youtube.com/@ItsBobbitto?sub_confirmation=1", color: "#FF0000" },
  { name: "TikTok", icon: "ri-tiktok-line", url: "https://www.tiktok.com/@itsbobbitto", color: "#ffffff" },
  { name: "Twitch", icon: "ri-twitch-line", url: "https://www.twitch.tv/itsbobbitto", color: "#9146FF" },
  { name: "X", icon: "ri-twitter-x-line", url: "https://x.com/itsbobbitto", color: "#ffffff" },
];

const serverIp = "applesmp.us";
const howToJoinUrl = "https://www.youtube.com/shorts/wrshTXQQSn4";

function SocialLink({ platform }: { platform: typeof socials[number] }) {
  return (
    <a
      href={platform.url}
      target="_blank"
      rel="noopener noreferrer"
      className="group flex items-center gap-2 rounded-xl border border-white/10 bg-white/[0.04] px-3 py-2 text-sm font-bold text-zinc-300 transition-all hover:border-white/20 hover:bg-white/[0.08] hover:text-white"
    >
      <i className={`${platform.icon} text-lg transition-transform group-hover:scale-110`} style={{ color: platform.color }} />
      <span>{platform.name}</span>
    </a>
  );
}

export default function HomePage() {
  const [serverStatus, setServerStatus] = useState<any>(null);
  const [customStats, setCustomStats] = useState<any>(null);
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    fetch("https://api.mcsrvstat.us/3/applesmp.us")
      .then((r) => r.json())
      .then(setServerStatus)
      .catch(() => setServerStatus({ online: false }));

    fetch("https://api.applesmp.us/stats")
      .then((r) => r.json())
      .then(setCustomStats)
      .catch(() => {});
  }, []);

  const copyIp = () => {
    navigator.clipboard.writeText(serverIp);
    setCopied(true);
    setTimeout(() => setCopied(false), 1800);
  };

  const isOnline = serverStatus?.online ?? false;
  const totalPlayers = customStats?.totalPlayers?.toLocaleString?.() ?? "75+";
  const liveViewers = 0;

  return (
    <div className="min-h-screen bg-[#090909] text-white selection:bg-red-500/30">
      <main className="relative mx-auto flex min-h-screen w-full max-w-5xl flex-col justify-center px-5 py-10">
        <div className="pointer-events-none absolute left-1/2 top-10 h-96 w-96 -translate-x-1/2 rounded-full bg-red-500/10 blur-[120px]" />
        <div className="pointer-events-none absolute bottom-16 right-10 h-72 w-72 rounded-full bg-sky-400/10 blur-[120px]" />

        <section className="relative grid gap-5 lg:grid-cols-[290px_1fr_220px]">
          <div className="flex flex-col gap-3">
            <div className="flex aspect-square items-center justify-center overflow-hidden rounded-[1.35rem] bg-[#ef4444] p-8 shadow-2xl shadow-black/30">
              <img
                src="/applepfp.png"
                alt="AppleSMP"
                className="h-full w-full object-contain drop-shadow-2xl"
                onError={(e) => {
                  (e.currentTarget as HTMLImageElement).src = "/apple.png";
                }}
              />
            </div>

            <button
              onClick={copyIp}
              className="group flex h-16 items-center justify-center gap-4 rounded-[1.35rem] bg-[#1d1d1f] px-6 text-xl font-black tracking-wide text-white shadow-xl shadow-black/25 transition-all hover:bg-[#26262a]"
            >
              <i className={copied ? "ri-checkbox-circle-fill text-emerald-400" : "ri-file-copy-line text-zinc-200"} />
              <span>{copied ? "COPIED" : "APPLESMP.US"}</span>
            </button>

            <Link
              to="/connect"
              className="group relative min-h-[155px] overflow-hidden rounded-[1.35rem] border border-white/10 bg-[#151515] p-5 shadow-xl shadow-black/25 transition-all hover:-translate-y-0.5 hover:border-sky-400/30"
            >
              <div className="absolute inset-0 bg-[radial-gradient(circle_at_82%_14%,rgba(56,189,248,0.20),transparent_34%),linear-gradient(135deg,rgba(12,27,45,0.92),rgba(12,12,15,0.98))]" />
              <div className="relative z-10 flex h-full flex-col justify-between gap-6">
                <div className="flex items-center justify-between">
                  <i className="ri-gamepad-line text-3xl text-sky-300" />
                  <span className="rounded-full border border-sky-300/20 bg-sky-300/10 px-2.5 py-1 text-[11px] font-black uppercase tracking-wide text-sky-200">
                    Console
                  </span>
                </div>
                <div>
                  <h2 className="text-2xl font-black">Play on Console</h2>
                  <p className="mt-1 text-sm font-semibold leading-5 text-white/60">
                    AppleSMP Bedrock setup for Xbox, PlayStation, and Switch.
                  </p>
                </div>
              </div>
            </Link>
          </div>

          <div className="grid gap-5">
            <Link
              to="/store"
              className="group relative min-h-[215px] overflow-hidden rounded-[1.35rem] border border-white/10 bg-[#151515] p-6 shadow-2xl shadow-black/25 transition-all hover:-translate-y-0.5 hover:border-red-500/30"
            >
              <div className="absolute inset-0 bg-[radial-gradient(circle_at_78%_20%,rgba(255,255,255,0.12),transparent_32%),linear-gradient(135deg,rgba(70,70,74,0.92),rgba(22,22,25,0.96))]" />
              <img
                src="/32000-shards.png"
                alt=""
                aria-hidden="true"
                className="absolute -right-6 top-3 h-48 w-48 rotate-12 object-contain opacity-100 drop-shadow-[0_24px_24px_rgba(0,0,0,0.55)] transition-transform duration-300 group-hover:translate-y-[-4px] group-hover:rotate-[17deg]"
              />
              <img
                src="/spawner-key.png"
                alt=""
                aria-hidden="true"
                className="absolute bottom-0 right-36 h-40 w-40 -rotate-12 object-contain opacity-100 drop-shadow-[0_22px_22px_rgba(0,0,0,0.55)] transition-transform duration-300 group-hover:-translate-y-2 group-hover:-rotate-[18deg]"
              />
              <div className="relative z-10 flex h-full flex-col justify-between">
                <div>
                  <h1 className="text-4xl font-black tracking-tight">Store</h1>
                  <p className="mt-2 max-w-md text-sm font-medium leading-6 text-white/75">
                    Ranks, crate keys, shards, and server support packages.
                  </p>
                </div>
                <div className="mt-8 inline-flex w-fit items-center gap-2 rounded-full bg-white px-4 py-2 text-sm font-black text-black transition-transform group-hover:translate-x-1">
                  Open Store <i className="ri-arrow-right-line" />
                </div>
              </div>
            </Link>

            <div className="grid gap-5 md:grid-cols-2">
              <Link
                to="/leaderboard"
                className="group relative min-h-[155px] overflow-hidden rounded-[1.35rem] border border-white/10 bg-[#151515] p-6 shadow-xl shadow-black/25 transition-all hover:-translate-y-0.5 hover:border-amber-400/30"
              >
                <div className="absolute inset-0 bg-[radial-gradient(circle_at_80%_20%,rgba(251,191,36,0.28),transparent_35%),linear-gradient(135deg,rgba(120,53,15,0.45),rgba(0,0,0,0.2))]" />
                <div className="relative z-10">
                  <i className="ri-bar-chart-box-line text-4xl text-amber-300" />
                  <h2 className="mt-4 text-3xl font-black">Stats</h2>
                  <p className="mt-2 text-sm font-medium leading-6 text-white/70">
                    View money, kills, playtime, deaths, and rankings.
                  </p>
                </div>
              </Link>

              <a
                href={howToJoinUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="group relative min-h-[155px] overflow-hidden rounded-[1.35rem] border border-white/10 bg-[#151515] p-6 shadow-xl shadow-black/25 transition-all hover:-translate-y-0.5 hover:border-sky-400/30"
              >
                <div className="absolute inset-0 bg-[radial-gradient(circle_at_18%_12%,rgba(34,211,238,0.28),transparent_34%),radial-gradient(circle_at_84%_88%,rgba(239,68,68,0.18),transparent_34%),linear-gradient(135deg,rgba(15,23,42,0.82),rgba(0,0,0,0.30))]" />
                <div className="absolute -right-8 -top-8 h-28 w-28 rounded-full border border-sky-300/20 bg-sky-300/10 blur-sm transition-transform duration-300 group-hover:scale-110" />
                <div className="relative z-10 flex h-full flex-col justify-between">
                  <div className="flex items-center justify-between">
                    <i className="ri-video-line text-4xl text-sky-300" />
                    <i className="ri-arrow-right-line text-2xl text-white/45 transition-transform group-hover:translate-x-1" />
                  </div>
                  <div>
                    <h2 className="text-3xl font-black leading-tight">How To Join</h2>
                    <p className="mt-2 text-sm font-semibold leading-5 text-white/65">
                      Watch the AppleSMP setup guide.
                    </p>
                  </div>
                </div>
              </a>
            </div>
          </div>

          <div className="grid gap-5">
            <a
              href="https://www.dsc.gg/applesmpofficial"
              target="_blank"
              rel="noopener noreferrer"
              className="flex min-h-[145px] flex-col items-center justify-center rounded-[1.35rem] border border-white/10 bg-[#1c1c1f] p-6 text-center shadow-xl shadow-black/25 transition-all hover:-translate-y-0.5 hover:border-indigo-400/30 hover:bg-[#222229]"
            >
              <i className="ri-discord-fill text-6xl text-indigo-400" />
              <p className="mt-4 text-3xl font-black">50+</p>
              <p className="mt-1 text-sm font-bold text-white/75">
                <span className="mr-1 inline-block h-2 w-2 rounded-full bg-emerald-400" />
                Discord Members
              </p>
            </a>

            <Link
              to="/live"
              className="group flex min-h-[135px] flex-col justify-between rounded-[1.35rem] border border-white/10 bg-[#151515] p-5 shadow-xl shadow-black/25 transition-all hover:-translate-y-0.5 hover:border-emerald-400/30"
            >
              <div className="flex items-center justify-between">
                <i className="ri-broadcast-line text-3xl text-emerald-300" />
                <span className={`rounded-full px-2.5 py-1 text-xs font-black ${isOnline ? "bg-emerald-500/15 text-emerald-300" : "bg-red-500/15 text-red-300"}`}>
                  {isOnline ? "LIVE" : "OFFLINE"}
                </span>
              </div>
              <div>
                <h2 className="text-2xl font-black">Live</h2>
                <p className="mt-1 text-sm text-white/60">{liveViewers.toLocaleString()} total viewers</p>
              </div>
            </Link>

            <Link
              to="/rules"
              className="group flex min-h-[135px] flex-col justify-between rounded-[1.35rem] border border-white/10 bg-[#151515] p-5 shadow-xl shadow-black/25 transition-all hover:-translate-y-0.5 hover:border-red-400/30"
            >
              <i className="ri-file-list-3-line text-3xl text-red-300" />
              <div>
                <h2 className="text-2xl font-black">Rules</h2>
                <p className="mt-1 text-sm text-white/60">Read before playing.</p>
              </div>
            </Link>
          </div>
        </section>

        <section className="relative mt-5 rounded-[1.35rem] border border-white/10 bg-[#151515] p-5 shadow-xl shadow-black/25">
          <div className="flex flex-col gap-5 md:flex-row md:items-center md:justify-between">
            <div>
              <p className="text-xs font-black uppercase tracking-[0.2em] text-red-300">Community</p>
              <h2 className="mt-2 text-2xl font-black">Follow AppleSMP</h2>
              <p className="mt-1 text-sm text-white/55">{totalPlayers} registered players tracked.</p>
            </div>
            <div className="flex flex-wrap gap-2">
              {socials.map((platform) => (
                <SocialLink key={platform.name} platform={platform} />
              ))}
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
